import { render } from "./PaymentErrorPayment.vue?vue&type=template&id=871d484a"
import script from "./PaymentErrorPayment.vue?vue&type=script&lang=js"
export * from "./PaymentErrorPayment.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__